/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Edge_ConfigInputs */

const cs_workflow_edge_config = /** @type {(inputs: Workflow_Edge_ConfigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konfigurace spojení`)
};

const en_workflow_edge_config = /** @type {(inputs: Workflow_Edge_ConfigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edge configuration`)
};

/**
* | output |
* | --- |
* | "Edge configuration" |
*
* @param {Workflow_Edge_ConfigInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_edge_config = /** @type {((inputs?: Workflow_Edge_ConfigInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Edge_ConfigInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_edge_config(inputs)
	return cs_workflow_edge_config(inputs)
});